import styled from 'styled-components';

import type { ControlWidth } from '@packages/core';

import { CONTROL_WIDTH_CSS } from './controlWidth';

export const FormFieldShell = styled.div.attrs<{ $controlWidth: ControlWidth }>((props) => ({
  'data-control-width': props.$controlWidth,
}))<{ $controlWidth: ControlWidth }>`
  box-sizing: border-box;
  width: 100%;
  max-width: ${({ $controlWidth }) => CONTROL_WIDTH_CSS[$controlWidth]};
  min-width: 0;

  & > * {
    width: 100%;
    max-width: 100%;
  }
`;
